import axios from "axios"
import { ProductPaginated } from "../../products-page/components/products-searched-view/models"

export const getProducerProducts = (pageNumber: number, pageSize: number, producerId: string) => {
    return axios.get<ProductPaginated>('products/distributorProducts/' + producerId + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize)
}